export var EAlkButtonFill;
(function (EAlkButtonFill) {
    EAlkButtonFill["SOLID"] = "solid";
    EAlkButtonFill["OUTLINE"] = "outline";
    EAlkButtonFill["CLEAR"] = "clear";
})(EAlkButtonFill || (EAlkButtonFill = {}));
